<template>
  <el-dialog
    title="选择素材"
    :visible="visible"
    width="1210px"
    top="5vh"
    append-to-body
    destroy-on-close
    @close="handleClose"
  >
    <AssetLibrary
      v-if="visible"
      :kinds="kinds"
      mode="pick"
      :multiple="multiple"
      :game-id="gameId"
      :default-scope="defaultScope"
      @pick="handlePick"
      @pick-many="handlePickMany"
    />
  </el-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import type { AssetKind, Asset, AssetScope } from '@/api/asset'
import AssetLibrary from './AssetLibrary.vue'

/**
 * 素材选择器：AssetLibrary 的薄包装，供业务方以 `:visible.sync` + `:kinds` 唤起。
 * 选中后通过 picked / picked-many 把结果交回业务方，并自动关闭自身——
 * 单选场景点卡片即确认（AssetLibrary.onCardClick 直接 emit pick，语义上就是"选定"），
 * 多选场景在用户点了 AssetLibrary 自带的"确定"按钮（emit pick-many）后才算完成。
 *
 * 这是后续所有计划的公共依赖（语句背景图/音频挂载、条件背景、角色立绘与可变形象、
 * 商城衣橱选图都会调用它），契约必须保持干净，不在这一层塞任何素材库之外的业务逻辑
 * ——包括不猜测调用方场景去定制标题，标题固定为"选择素材"。
 *
 * append-to-body：预期会被嵌套在别的弹窗/面板里调用，挂到 body 下避免被祖先的
 * overflow/z-index 裁切或压住。
 *
 * 宽度 1210 跟 AssetManagerDialog 一致（左栏 330 + 右侧 840 + 内边距 40），改要两处一起改。
 */
@Component({ components: { AssetLibrary } })
export default class AssetPickerDialog extends Vue {
  @Prop({ required: true }) readonly visible!: boolean
  @Prop({ required: true }) readonly kinds!: AssetKind[]
  @Prop({ default: false }) readonly multiple!: boolean
  /** 所属书 id，原样透传给 AssetLibrary——有值(>0)才会显示"本书素材"(book)页签（六项 D 计划 F2；
      2026-09-18 本书素材库改造起该页签不再只读，见 AssetLibrary.canWrite） */
  @Prop({ default: 0 }) readonly gameId!: number
  /** 初始范围页签，透传给 AssetLibrary。默认 'book'：2026-10-16 起各处选素材弹窗（语句背景图、
      挂载音频、商城、衣橱等）统一先落在本书素材，此前只有角色管理是（2026-10-09）。
      gameId 无效时 AssetLibrary 自己回落 mine */
  @Prop({ default: 'book' }) readonly defaultScope!: AssetScope

  handlePick(a: Asset) {
    this.$emit('picked', a)
    this.handleClose()
  }

  handlePickMany(list: Asset[]) {
    this.$emit('picked-many', list)
    this.handleClose()
  }

  handleClose() {
    this.$emit('update:visible', false)
  }
}
</script>

<style scoped lang="scss">
</style>
